import { render, staticRenderFns } from "./users.vue?vue&type=template&id=24350f66&scoped=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"
import style0 from "./users.vue?vue&type=style&index=0&id=24350f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24350f66",
  null
  
)

export default component.exports